import React from 'react';

export default function PageContainer({ className = '', children }) {
  return <div className={`space-y-4 ${className}`}>{children}</div>;
}
